if (!customElements.get('newsletter-popup')) {
  customElements.define(
    'newsletter-popup',
    class NewsletterPopup extends HTMLElement {
      static STORAGE_KEY = 'yeoshin-newsletter-popup';

      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.form = this.closest('form');
        this.pendingKey = `${NewsletterPopup.STORAGE_KEY}:pending:${this.dataset.sectionId}`;

        this.querySelectorAll('[data-close]').forEach((button) => button.addEventListener('click', () => this.close()));
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close();
        });
        this.dialog.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') this.close();
        });
        this.form.addEventListener('submit', () => this.onSubmit());

        if (window.Shopify && Shopify.designMode) {
          document.addEventListener('shopify:section:select', this.onSectionSelect);
          document.addEventListener('shopify:section:deselect', this.onSectionDeselect);
          return;
        }

        // A customer form just posted. If it was this one, show the result now; if it was another
        // (e.g. the footer newsletter), stay hidden. Either way a successful signup is remembered.
        if (this.dataset.posted) {
          if (this.dataset.posted === 'success') this.remember();
          if (read(sessionStorage, this.pendingKey)) {
            write(sessionStorage, this.pendingKey, null);
            this.open();
          }
          return;
        }

        // ?popup in the address always shows it (for checking the design).
        if (/[?&]popup\b/.test(window.location.search)) {
          this.timer = setTimeout(() => this.open(), 300);
          return;
        }

        // Visitors who closed it see it again after N days (default 14).
        const seenAt = Number(read(localStorage, NewsletterPopup.STORAGE_KEY));
        const repeatMs = Number(this.dataset.repeatDays || 14) * 24 * 60 * 60 * 1000;
        if (seenAt && Date.now() - seenAt < repeatMs) return;
        this.timer = setTimeout(() => this.openAfterCookieBanner(), Number(this.dataset.delay || 0) * 1000);
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        this.bannerObserver?.disconnect();
        document.removeEventListener('shopify:section:select', this.onSectionSelect);
        document.removeEventListener('shopify:section:deselect', this.onSectionDeselect);
      }

      onSectionSelect = (event) => {
        if (event.detail.sectionId === this.dataset.sectionId) this.open();
      };

      onSectionDeselect = (event) => {
        if (event.detail.sectionId === this.dataset.sectionId) this.dialog.close();
      };

      onSubmit() {
        const tags = this.form.querySelector('[data-tags]');
        const skinType = this.form.querySelector('[data-skin-type]');
        tags.value = skinType && skinType.value ? `newsletter, Hudtyp: ${skinType.value}` : 'newsletter';
        write(sessionStorage, this.pendingKey, '1');
      }

      // Shopify's cookie banner shares the bottom of the screen, so wait until the visitor has answered it.
      openAfterCookieBanner() {
        const banner = document.getElementById('shopify-pc__banner');
        const bannerShowing = () => banner.isConnected && getComputedStyle(banner).display !== 'none';
        if (!banner || !bannerShowing()) return this.open();

        this.bannerObserver = new MutationObserver(() => {
          if (bannerShowing()) return;
          this.bannerObserver.disconnect();
          this.open();
        });
        this.bannerObserver.observe(banner, { attributes: true });
        this.bannerObserver.observe(document.body, { childList: true });
      }

      open() {
        if (this.dialog.open) return;
        // Non-modal: the page stays usable while the card is up.
        this.dialog.show();
        // Leave focus where the visitor is (e.g. typing in search); otherwise focus the card, not the X,
        // so no focus ring shows until the visitor tabs.
        const active = document.activeElement;
        if (active && active !== document.body && !this.dialog.contains(active)) {
          active.focus({ preventScroll: true });
        } else {
          this.dialog.focus({ preventScroll: true });
        }
      }

      close() {
        this.remember();
        this.dialog.close();
      }

      remember() {
        if (!(window.Shopify && Shopify.designMode)) write(localStorage, NewsletterPopup.STORAGE_KEY, String(Date.now()));
      }
    }
  );

  function read(storage, key) {
    try {
      return storage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function write(storage, key, value) {
    try {
      value === null ? storage.removeItem(key) : storage.setItem(key, value);
    } catch (e) {
      // Storage blocked (private mode etc.): the popup just shows again next visit.
    }
  }
}
